import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const AppointmentRegistration = ({screenAction, triggerSave}) => {

const [formData,setFormData] = useState({
patient_id:"",
appointment_id:"",
doctor_id:"",
doctor_name:"",
department:"",
doctor_availability:"",
appointment_datetime:"",
reason:"",
consultation_fee:""
});

const [isDisabled, setIsDisabled] = useState(true);
const [searchText, setSearchText] = useState("");
const [appointments, setAppointments] = useState([]);
const [showDropdown, setShowDropdown] = useState(false);
const [patientSearch, setPatientSearch] = useState("");
const [patientList, setPatientList] = useState([]);
const [showPatientDropdown, setShowPatientDropdown] = useState(false);
const [doctorList, setDoctorList] = useState([]);

useEffect(()=>{

const date = new Date();
const id = `APT-${date.getFullYear()}-${Math.floor(1000 + Math.random()*9000)}`;

setFormData(prev=>({
...prev,
appointment_id:id
}));

},[]);

const handleChange = (e)=>{
setFormData({
...formData,
[e.target.name]:e.target.value
});
};

const searchAppointments = async (text) => {
  setSearchText(text);

  if (text.length < 2) {
    setAppointments([]);
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    ` https://hmsapi.emedhatechnologies.com/master/api/api/appointments/search?q=${text}&employee_id=${user.id}`
  );

  const data = await res.json();

  setAppointments(data);
  setShowDropdown(true);
};

useEffect(() => {
  const fetchDoctors = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    const res = await fetch(
      `https://hmsapi.emedhatechnologies.com/master/api/doctors/appointment?employee_id=${user.id}`
    );

    const data = await res.json();
    setDoctorList(data);
  };

  fetchDoctors();
}, []);

const searchPatients = async (text) => {

  setPatientSearch(text);

  // ❗ if user clears input → reset
  if (!text) {
    setPatientList([]);
    setShowPatientDropdown(false);
    return;
  }

  if (text.length < 2) {
    setPatientList([]);
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/api/search?q=${text}&employee_id=${user.id}`
  );

  const data = await res.json();

  setPatientList(data);
  setShowPatientDropdown(true);
};


const selectPatient = (p) => {
  setFormData((prev) => ({
    ...prev,
    patient_id: p.patient_id,
    patient_name: p.name,     // ✅ add this
    mobile: p.mobile          // ✅ add this
  }));

  setPatientSearch(
    `${p.patient_id} | ${p.name} | ${p.mobile}`
  );

  setShowPatientDropdown(false);
};

const selectAppointment = (appt) => {

  const cleanDateTime = (d) => {
    if (!d) return "";
    return d.replace(" ", "T").slice(0, 16);
  };

  setFormData({
    ...appt,
    appointment_datetime: cleanDateTime(appt.appointment_datetime)
  });

  setSearchText(
    `${appt.appointment_id} | ${appt.patient_name} | ${appt.mobile}`
  );

  setShowDropdown(false);

  // 🔥 CONTROL MODE
  if (screenAction === "edit") {
    setIsDisabled(false); // ENABLE editing
  }

  if (screenAction === "view") {
    setIsDisabled(true); // READ ONLY
  }
};


const getNewAppointmentId = () => {
  const date = new Date();
  return `APT-${date.getFullYear()}-${Math.floor(1000 + Math.random()*9000)}`;
};

const clearForm = () => {
  setFormData({
    patient_id: "",
    appointment_id: getNewAppointmentId(),
    doctor_id: "",
    doctor_name: "",
    department: "",
    doctor_availability: "",
    appointment_datetime: "",
    reason: "",
    consultation_fee: ""
  });
     


  setSearchText("");
  setAppointments([]);
  setShowDropdown(false);
};


useEffect(() => {
  if (triggerSave > 0 && screenAction === "save") {
    handleSubmit();
  }
}, [triggerSave]);



const fetchDoctorDetails = async (doctorId) => {
  if (!doctorId) return;

  const user = JSON.parse(localStorage.getItem("user"));

  try {
    const res = await fetch(
      `https://hmsapi.emedhatechnologies.com/master/api/doctor/${doctorId}?employee_id=${user.id}`
    );

    if (!res.ok) {
      console.warn("Doctor not found");
      return;
    }

    const data = await res.json();

    setFormData((prev) => ({
      ...prev,
      doctor_id: data.doctor_id,
      doctor_name: data.doctor_name,
      department: data.department,
      consultation_fee: data.consultation_fee
    }));
  } catch (err) {
    console.error(err);
  }
};


// const handleSubmit = (e)=>{
// e.preventDefault();
// console.log("Appointment Data:",formData);
// alert("Appointment Booked Successfully");
// };


useEffect(() => {

  if (screenAction === "add") {
    clearForm();
    setIsDisabled(false); // enable inputs
  }

  if (screenAction === "edit") {
    clearForm();          // EMPTY form first
    setIsDisabled(false);  // disable until search
  }

  if (screenAction === "view") {
    clearForm();          // EMPTY form first
    setIsDisabled(true);  // always read-only
  }

  if (screenAction === "print") {
      printForm(); // Trigger print
    }

  // if (screenAction === "save") {
  //   handleSubmit();
  // }

}, [screenAction]);


const printForm = () => {
    const newWindow = window.open("", "", "width=900,height=700");
    const today = new Date().toLocaleDateString();

    const htmlContent = `
      <html>
        <head>
          <title>Appointment Slip - ${formData.appointment_id}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2c3e50; padding-bottom: 10px; margin-bottom: 20px; }
            .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
            .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
            .report-title { text-align: right; }
            .report-title h2 { margin: 0; color: #27ae60; font-size: 18px; }
            
            .section-header { background: #f2f4f4; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #27ae60; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
            
            .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
            .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 4px 0; }
            .label { font-weight: 600; width: 160px; color: #555; }
            .value { flex: 1; color: #000; font-weight: 500; }
            .full-width { grid-column: span 2; }

            .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
            .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
            .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

            @media print {
              body { padding: 20px; }
              @page { margin: 0.5cm; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="hospital-info">
              <h1>EMEDHA CARE HOSPITAL</h1>
              <p>123 Medical Park, Health City - 560001</p>
              <p>Phone: +91 98765 43210 | Email: contact@citycare.com</p>
            </div>
            <div class="report-title">
              <h2>APPOINTMENT SLIP</h2>
              <p>Print Date: ${today}</p>
            </div>
          </div>

          <div class="section-header">Appointment Details</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Appointment ID:</span> <span class="value">${formData.appointment_id}</span></div>
            <div class="data-item"><span class="label">Date & Time:</span> <span class="value">${formData.appointment_datetime.replace("T", " ")}</span></div>
            <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
            <div class="data-item"><span class="label">Visit Type:</span> <span class="value">Consultation</span></div>
          </div>

          <div class="section-header">Consultant Information</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Doctor Name:</span> <span class="value">Dr. ${formData.doctor_name}</span></div>
            <div class="data-item"><span class="label">Doctor ID:</span> <span class="value">${formData.doctor_id}</span></div>
            <div class="data-item full-width"><span class="label">Department:</span> <span class="value">${formData.department}</span></div>
          </div>

          <div class="section-header">Clinical Note</div>
          <div class="data-grid">
            <div class="data-item full-width"><span class="label">Reason / Symptoms:</span> <span class="value">${formData.reason || 'N/A'}</span></div>
          </div>

          <div class="section-header">Billing Summary</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Consultation Fee:</span> <span class="value">₹ ${formData.consultation_fee || '0.00'}</span></div>
            <div class="data-item"><span class="label">Payment Status:</span> <span class="value">Pending at Counter</span></div>
          </div>

          <div class="sig-box">
            <div class="sig">Patient Signature</div>
            <div class="sig">Reception Desk</div>
          </div>

          <div class="footer">
            Please arrive 15 minutes before your scheduled time. 
            Bring this slip to the consultation room.
          </div>
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();
    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

  useEffect(() => {
  const handleClickOutside = () => {
    setShowPatientDropdown(false);
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);

const handleSubmit = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!formData.patient_id) {
    alert("Patient required");
    return;
  }

  const payload = { ...formData };

    if (!payload.patient_name) delete payload.patient_name;
  if (!payload.mobile) delete payload.mobile;

  delete payload.created_at;
  delete payload.updated_at;
  delete payload.patient_name;
  delete payload.mobile;

  payload.created_by = user.id;

  if (payload.appointment_datetime) {
    payload.appointment_datetime =
      payload.appointment_datetime.replace("T", " ") + ":00";
  }

  const method = formData.created_at ? "PUT" : "POST";

  const url =
    method === "POST"
      ? "https://hmsapi.emedhatechnologies.com/master/api/api/appointment"
      : `https://hmsapi.emedhatechnologies.com/master/api/api/appointment/${formData.appointment_id}`;

  const res = await fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (res.ok) {
    alert("Appointment Saved");
    if (method === "POST"){ clearForm();

          setIsDisabled(false);
    }
  }
};


return(




<div className="registration-container fade-in">
{(screenAction === "edit" || screenAction === "view") && (
  <div className="patient-search">

    <label>Search Appointment</label>

    <input
      type="text"
      value={searchText}
      placeholder="Search by Appointment ID / Patient / Mobile"
      onChange={(e) => searchAppointments(e.target.value)}
    />

    {showDropdown && appointments.length > 0 && (
      <div className="patient-dropdown">
        {appointments.map((a) => (
          <div
            key={a.appointment_id}
            className="patient-item"
            onClick={() => selectAppointment(a)}
          >
            {a.appointment_id} | {a.patient_id} | {a.patient_name} | {a.mobile} 
             <span
      style={{
        marginLeft: "10px",
        padding: "2px 8px",
        borderRadius: "12px",
        fontSize: "11px",
        backgroundColor: a.source === "BOT" ? "#25D366" : "#3498db",
        color: "#fff"
      }}
    >
      {a.source === "BOT" ? "WhatsApp" : "HMS"}
    </span>
          </div>
        ))}
      </div>
    )}
  </div>
)}
{screenAction === "view" && formData.appointment_id && (
  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px'  , marginTop: '10px'}}>
            <button 
              type="button"
              onClick={() => alert(`Share Appointment ${formData.appointment_id} details via WhatsApp!`)}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#25D366', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(37, 211, 102, 0.3)', height: '36px' }}
              title="Share via WhatsApp"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
              </svg>
              WhatsApp
            </button>
                  </div>
          )}
    
     
<form className="luxury-form" >

<div className="form-section-header">
<h3>Appointment Booking</h3>
 {formData.source && (
    <span
      style={{
        marginLeft: "10px",
        padding: "4px 10px",
        borderRadius: "14px",
        fontSize: "12px",
        backgroundColor:
          formData.source === "BOT" ? "#25D366" : "#3498db",
        color: "#fff"
      }}
    >
      {formData.source === "BOT" ? "WhatsApp Booking" : "HMS Booking"}
    </span>
  )}
<p>Schedule a new patient consultation</p>
</div>

<div className="form-grid">

<div className="input-box">
  <label>Patient</label>

  <input
    type="text"
    placeholder="Search Patient ID / Name / Mobile"
    value={patientSearch}
    disabled={isDisabled}
    onChange={(e) => {
  setShowPatientDropdown(true); // reopen only when typing
  searchPatients(e.target.value);
}}
  />

  {showPatientDropdown && patientList.length > 0 && (
    <div className="patient-dropdown">
      {patientList.map((p) => (
        <div
          key={p.patient_id}
          className="patient-item"
          onClick={() => selectPatient(p)}
        >
          {p.patient_id} | {p.name} | {p.mobile}

          <span
            style={{
              marginLeft: "10px",
              padding: "2px 8px",
              borderRadius: "12px",
              fontSize: "11px",
              backgroundColor:
                p.source === "BOT" ? "#25D366" : "#3498db",
              color: "#fff"
            }}
          >
            {p.source === "BOT" ? "WhatsApp" : "HMS"}
          </span>
        </div>
      ))}
    </div>
  )}
</div>

<div className="input-box read-only">
<label>Appointment ID</label>
<input
type="text"
name="appointment_id"

  disabled={isDisabled}
    value={formData.appointment_id || ""} 
readOnly
/>
</div>

<div className="input-box">
  <label>Doctor</label>

  <select
    name="doctor_id"
    disabled={isDisabled}
    value={formData.doctor_id || ""}
    onChange={(e) => {
      const selectedId = e.target.value;

      const selectedDoctor = doctorList.find(
        (d) => d.doctor_id === selectedId
      );

      setFormData((prev) => ({
        ...prev,
        doctor_id: selectedDoctor?.doctor_id || "",
        doctor_name: selectedDoctor?.doctor_name || "",
        department: selectedDoctor?.department || "",
        consultation_fee: selectedDoctor?.consultation_fee || ""
      }));
    }}
  >
    <option value="">Select Doctor</option>

    {doctorList.map((doc) => (
      <option key={doc.doctor_id} value={doc.doctor_id}>
        {doc.doctor_id} - {doc.doctor_name}
      </option>
    ))}
  </select>
</div>

<div className="input-box">
<label>Doctor Name</label>
<input
type="text"
name="doctor_name"
placeholder="Doctor Name"
onChange={handleChange}
  disabled={isDisabled}
    value={formData.doctor_name || ""} 
/>
</div>

<div className="input-box">
<label>Department / Specialization</label>
<input
type="text"
name="department"
placeholder="Cardiology / Orthopedics"
onChange={handleChange}
  disabled={isDisabled}
    value={formData.department || ""} 
/>
</div>

<div className="input-box">
<label>Doctor Availability</label>
<select
name="doctor_availability"
onChange={handleChange}
  disabled={isDisabled}
    value={formData.doctor_availability || ""} 
>
<option value="">Select Availability</option>
<option>Morning</option>
<option>Afternoon</option>
<option>Evening</option>
</select>
</div>

<div className="input-box">
<label>Time Slot (Date & Time)</label>
<input
type="datetime-local"
name="appointment_datetime"
onChange={handleChange}
  disabled={isDisabled}
    value={formData.appointment_datetime || ""} 
/>
</div>

<div className="input-box full-width">
<label>Reason for Visit / Symptoms</label>
<textarea
name="reason"
placeholder="Describe symptoms..."
onChange={handleChange}
  disabled={isDisabled}
    value={formData.reason || ""} 
/>
</div>

<div className="input-box">
<label>Consultation Fees</label>
<input
type="number"
name="consultation_fee"
placeholder="Enter Fee"
onChange={handleChange}
  disabled={isDisabled}
  value={formData.consultation_fee || ""} 
/>
</div>

</div>
    {/*
<div className="form-footer">
<button type="reset" className="btn-secondary">Clear</button>
<button type="submit" className="btn-save">Book Appointment</button>
</div> */}

</form>

</div>

);
};

export default AppointmentRegistration;